import React from "react";

import ViewContainer from "../../../../components/layout/view/ViewContainer";
import ViewHeader from "../../../../components/layout/view/ViewHeader";
import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentItem from "../../../../components/layout/content/ContentItem";

import Text from "../../../../components/typography/Text";

export default function TalentOverviewView({ profile }) {
  return (
    <ViewContainer>
      <ViewHeader
        title="Talent Overview"
        description="My sporting profile and journey."
      />

      <ContentPanel>
        {!profile?.bio ? (
          <Text as="p">No bio added yet.</Text>
        ) : (
          <ContentItem>
            <Text as="p" className="user-talent__body">
              {profile?.bio || "No bio added yet."}
            </Text>
          </ContentItem>
        )}
      </ContentPanel>
    </ViewContainer>
  );
}
